<template>
  <div class="custom-find">
    <div class="find-container">
      <div class="title">
        找回密码
      </div>
      <div
        class="find-form"
        @click="validate.allMsg = ''"
      >
        <div class="form">
          <label>账号</label>
          <input
            v-model="findData.account"
            placeholder="请输入手机号或邮箱"
            maxlength="50"
            @focus="formatAcount"
            @blur="checkAccount"
          >
          <div
            v-if="validate.account"
            class="check-right"
          ></div>
          <p class="error">
            {{ validate.accountMsg }}
          </p>
          <p class="error">
            {{ validate.allMsg }}
          </p>
        </div>
        <div class="form-box">
          <div class="form">
            <label>图形验证</label>
            <input
              v-model="imgsrc.captcha"
              placeholder="请输入右侧数字"
              maxlength="10"
              @focus="formatCaptcha"
              @change="changeCaptcha"
            >
            <div
              v-if="validate.imgCaptcha"
              class="check-right code-right"
            ></div>
            <p class="error imgerror">
              {{ validate.imgCaptchaMsg }}
            </p>
          </div>
          <span class="form-imgcaptcha">
            <img
              :src="'/webapi' + imgsrc.imgurl"
              @click="refreshCaptcha"
            >
          </span>
        </div>
        <div class="form-box">
          <div class="form">
            <label>验证码</label>
            <input
              v-model="findData.verifyCode"
              placeholder="请输入验证码"
              maxlength="10"
              @focus="formatCode"
            >
            <p class="error code-error">
              {{ validate.verifyCodeMsg }}
            </p>
          </div>
          <button
            ref="regBtn"
            class="imgcode"
            @click="reSendVerifyCode"
          >
            获取验证码
          </button>
        </div>
        <div class="form">
          <label>重置密码</label>
          <input
            v-model="findData.psw"
            placeholder="请输入新密码(6-20位数字或英文)"
            :type="pwdType"
            maxlength="20"
            @blur="checkPsw"
            @focus=";(validate.psw = false), (validate.pswMsg = '')"
          >
          <div
            v-if="findData.psw"
            class="pwd-clear"
            @click="clearPwd"
          >
            <iconfont-hover
              width="10px"
              height="10px"
              initial-name="#icon-close"
              hover-name="#icon-close-hover"
              class="close-btn"
            >
            </iconfont-hover>
          </div>
          <div
            class="pwd-show"
            :class="{ active: idPwdShow }"
            @click="changePwdType"
            @blur="checkPsw"
          ></div>
          <div
            v-if="validate.psw"
            class="check-right"
          ></div>
          <p class="error psw-error">
            {{ validate.pswMsg }}
          </p>
        </div>
      </div>
      <div class="next-box">
        <div
          class="next-button"
          @click="submit"
        >
          确认
        </div>
        <div class="back-login">
          想起密码了，返回<span @click="goTo('login')">登录</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapMutations } from 'vuex'

export default {
  name: 'FindPwdDialog',
  props: {
    visibleStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      idPwdShow: false,
      pwdType: 'password',
      countdown: 60,
      stop_msg: false, // 控制修改phone，图形验证码的修改
      imgsrc: {
        // 图形验证码
        captcha: '',
        imgurl: ''
      },
      findData: {
        account: '',
        verifyCode: '',
        psw: ''
      },
      validate: {
        account: false,
        accountMsg: '',
        imgCaptcha: false,
        imgCaptchaMsg: '',
        verifyCode: false,
        verifyCodeMsg: '',
        psw: false,
        pswMsg: '',
        allMsg: ''
      },
      codeFlag: false, //验证只需不为空
      otherFlag: false, //其他输入框需校验正确
      analysis: {
        meiqia: { category: 'custom_service', action: 'click_meiqia', label: '美洽客服' }
      },
      isSendCode: false
    }
  },
  computed: {
    // submitBtnDisabled: function() {
    //   //默认隐藏注册按钮，填写正确后显示
    //   return !(this.codeFlag && this.otherFlag);
    // }
  },
  watch: {
    findData: {
      handler: function(val) {
        this.codeFlag = val.verifyCode != ''
      },
      deep: true
    },
    validate: {
      handler: function(val) {
        this.otherFlag = val.account && val.imgCaptcha && val.psw
      },
      deep: true
    },
    visibleStatus(val) {
      if (val) {
        this.refreshCaptcha()
      }
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  beforeDestroy() {
    this.findData.account = ''
    this.findData.verifyCode = ''
    this.findData.psw = ''
    this.imgsrc.captcha = ''
    this.validate.account = false
    this.validate.accountMsg = ''
    this.validate.imgCaptcha = false
    this.validate.imgCaptchaMsg = ''
    this.validate.psw = false
    this.validate.pswMsg = ''
    this.validate.allMsg = ''
    this.$refs.regBtn.removeAttribute('disabled')
    this.$refs.regBtn.innerText = '获取验证码'
    this.countdown = 60
    this.stop_msg = false
    this.isSendCode = false
    this.changeFindPwdVisible(false)
  },
  methods: {
    ...mapMutations(['changeFindPwdVisible']),
    formatCaptcha(value) {
      if (!this.validate.imgCaptcha) {
        this.validate.imgCaptcha = false
      }
      this.validate.imgCaptchaMsg = ''
    },
    formatAcount(value) {
      this.validate.account = false
      this.validate.accountMsg = ''
      return value
    },
    formatCode(value) {
      this.validate.verifyCode = false
      this.validate.verifyCodeMsg = ''
      return value
    },
    changeCaptcha() {
      this.validate.imgCaptcha = false
      this.validate.imgCaptchaMsg = ''
    },
    //显示隐藏密码
    changePwdType() {
      this.idPwdShow = !this.idPwdShow
      this.pwdType = this.pwdType === 'password' ? 'text' : 'password'
    },
    //更新图形验证码
    refreshCaptcha() {
      var times = Date.parse(new Date())
      this.imgsrc.imgurl = '/verify/imgCaptcha/new' + '?num=' + times
      this.validate.imgCaptcha = false
    },
    //校验图形验证码
    checkCaptchaImg() {
      if (this.imgsrc.captcha != '' && !this.validate.imgCaptcha) {
        return new Promise((resolve, reject) => {
          this.$http
            .put('/verify/imgCaptcha', {
              captcha: this.imgsrc.captcha
            })
            .then((response) => {
              var _data = response.data
              if (_data.code == 200) {
                this.validate.imgCaptcha = true
                resolve(true)
              } else {
                this.validate.imgCaptchaMsg = '图形验证码错误'
                resolve(false)
              }
            })
            .catch((response) => {
              //失败
            })
        })
      } else if (this.imgsrc.captcha == '') {
        this.validate.imgCaptchaMsg = '请输入图形验证码'
        return false
      } else {
        return true
      }
    },
    //请求校验账号是否注册
    checkAcc() {
      return new Promise((resolve, reject) => {
        this.$http
          .get('/user/account', {
            params: { acc: this.findData.account }
          })
          .then((response) => {
            var _data = response.data
            if (_data.code == 200) {
              resolve(true)
            } else {
              this.validate.accountMsg = _data.msg
            }
          })
      })
    },
    //校验账号是否注册和是否正确
    async checkAccount() {
      if (!this.findData.account.length) {
        this.validate.accountMsg = '请输入账号'
        return false
      }
      let email = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      let phone = /^(0|86|17951|12593)?((13[0-9])|(14[014]0[0-9])|(14[5-9])|(15([0-3]))|(15([5-9]))|(16[2567])|(170[0-9])|(174[0-5])|(17[1235678])|(18[0-9])|(19[012356789]))\d{8}$/
      if (email.test(this.findData.account)) {
        // console.log('邮箱')
        let result = await this.checkAcc()
        if (result) {
          this.jphoneORemail = 1
          this.validate.account = true
          return true
        }
      } else if (phone.test(this.findData.account)) {
        let result = await this.checkAcc()
        if (result) {
          this.jphoneORemail = 0
          this.validate.account = true
          return true
        }
      } else {
        this.validate.accountMsg = '请输入正确手机号码或邮箱'
        this.validate.account = false
        return false
      }
    },
    //重新发送验证码
    async reSendVerifyCode() {
      // 神策埋点：点击获取短信验证码按钮
      this.$store.commit('sensors/getCode2Sensors', { serviceType: '找回密码' })

      const isAcc = await this.checkAccount()
      const isImgc = await this.checkCaptchaImg()
      if (!(isAcc && isImgc)) {
        return
      } else if (!this.isSendCode) {
        this.sendVerifyCode()
      } else {
        this.refreshCaptcha()
        this.imgsrc.captcha = ''
        this.validate.imgCaptchaMsg = '请输入图形验证码'
        this.validate.verifyCodeMsg = ''
        this.validate.verifyCode = false
        this.findData.verifyCode = ''
        this.isSendCode = false
      }
    },
    //发送验证码
    sendVerifyCode() {
      this.$http
        .get('/verify/new', {
          params: {
            phone: this.jphoneORemail == 0 ? this.findData.account : '',
            email: this.jphoneORemail == 1 ? this.findData.account : '',
            captcha: this.imgsrc.captcha,
            servide_type: '找回密码'
          }
        })
        .then((response) => {
          var _data = response.data
          if (_data.code == 200) {
            this.setTime()
            this.isSendCode = true
          } else {
            this.validate.imgCaptchaMsg = _data.msg
          }
        })
        .catch((response) => {
          //失败
        })
    },
    //校验验证码
    checkVerifyCode() {
      if (this.findData.verifyCode != '') {
        return new Promise((resolve, reject) => {
          this.$http
            .put('/verify', {
              phone: this.jphoneORemail == 0 ? this.findData.account : '',
              email: this.jphoneORemail == 1 ? this.findData.account : '',
              code: this.findData.verifyCode
            })
            .then((response) => {
              var _data = response.data
              switch (_data.code) {
                case 200:
                  this.validate.verifyCode = true
                  resolve(true)
                  break
                default:
                  this.validate.verifyCodeMsg = _data.msg
                  resolve(false)
                  break
              }
            })
            .catch((response) => {
              //失败
              reject()
            })
        })
      } else {
        this.validate.verifyCodeMsg = '请输入验证码'
        return false
      }
    },
    //验证码计时
    setTime() {
      if (!this.visible) {
        return
      }
      if (this.countdown == 0) {
        this.$refs.regBtn.removeAttribute('disabled')
        this.$refs.regBtn.innerText = '重新获取验证码'
        this.countdown = 60
        this.stop_msg = false
        return false
      } else {
        this.$refs.regBtn.setAttribute('disabled', true)
        this.countdown--
        this.$refs.regBtn.innerText = '重新发送(' + this.countdown + ')'
        this.stop_msg = true
      }
      setTimeout(() => {
        this.setTime()
      }, 1000)
    },
    //校验密码格式是否正确
    checkPsw() {
      let reg = /^[a-zA-Z0-9]{6,20}$/
      if (!reg.test(this.findData.psw)) {
        this.validate.pswMsg = '请输入6-20位数字或英文'
        this.validate.psw = false
        return false
      }
      this.validate.pswMsg = ''
      this.validate.psw = true
      return true
    },
    clearPwd() {
      this.findData.psw = ''
      this.validate.psw = false
    },
    //非空校验
    isNull() {
      let flag = true
      const valid = [
        { name: 'account', text: '帐号' },
        { name: 'verifyCode', text: '验证码' },
        { name: 'psw', text: '密码' }
      ]
      for (const [key, val] of Object.entries(this.findData)) {
        valid.forEach((item) => {
          if (item.name == key && val == '') {
            this.validate[key] = false
            this.validate[key + 'Msg'] = '请输入' + item.text
            flag = false
          }
        })
      }
      if (this.imgsrc.captcha == '') {
        this.validate.imgCaptcha = false
        this.validate.imgCaptchaMsg = '请输入图形验证码'
        flag = false
      }
      return flag
    },
    //提交请求
    async submit() {
      if (!this.isNull()) {
        return
      }
      console.log('非空通过')
      if (!this.checkPsw()) {
        return
      }
      console.log('密码通过')
      //验证码校验
      if (await this.checkVerifyCode()) {
        console.log('验证码通过')
        this.$http
          .put('/user/password', {
            action: 'find',
            phone: this.jphoneORemail == 0 ? this.findData.account : '',
            email: this.jphoneORemail == 1 ? this.findData.account : '',
            psw: this.findData.psw
          })
          .then((response) => {
            var _data = response.data
            if (_data.code == 200) {
              this.$message({
                message: '已修改成功',
                type: 'success'
              })
              this.goTo('login', 'mobile')
              this.changeFindPwdVisible(false)
            } else {
              this.validate.allMsg = _data.msg
            }
          })
          .catch((response) => {})
      }
    },
    //跳转到页面
    goTo(str, str2) {
      this.$emit('goto', str, str2)
      this.changeFindPwdVisible(false)
    }
  }
}
</script>

<style lang="scss">
.find-container {
  border-radius: 5px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: 35px;
  background: #fff;
  .title {
    font-size: 18px;
  }
  .find-form {
    text-align: left;
    padding: 40px 50px;
    .form-box {
      display: flex;
      .form {
        width: 68%;
        input {
          font-size: 14px;
          width: 100px;
        }
      }
      span {
        background: #f7f6fc;
        margin-left: 10px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        text-align: center;
      }
      button.imgcode {
        margin-left: 10px;
        width: 145px;
        height: 40px;
        color: #606266;
        text-align: center;
        box-sizing: border-box;
        background: #f7f6fc;
        border-radius: 4px;
        cursor: pointer;
        &:disabled {
          cursor: not-allowed;
        }
      }
      .form-imgcaptcha {
        width: 126px;
        margin-left: 10px;
        height: 40px;
        background: #fff;
        img {
          width: 126px;
          height: 40px;
        }
      }
    }
    .form {
      position: relative;
      border-bottom: 1px solid #eee;
      margin-bottom: 30px;
      height: 40px;
      line-height: 40px;
      input {
        width: 68%;
        font-size: 14px;
      }
      input::placeholder {
        color: #c2c2d9;
        font-size: 14px;
      }
      label {
        margin-right: 20px;
      }
      .pwd-clear {
        width: 23px;
        height: 23px;
        cursor: pointer;
        position: absolute;
        right: 30px;
        top: 10px;
      }
      .pwd-show {
        width: 23px;
        height: 23px;
        transform: scale(0.66);
        background: url(./icons/pwd-show.png) no-repeat center / contain;
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 10px;
        &.active {
          background: url('./icons/pwd-show.png') no-repeat center / contain;
        }
      }
      .check-right {
        width: 23px;
        height: 23px;
        transform: scale(0.66);
        background: url(./icons/check-right.png) no-repeat;
        position: absolute;
        right: -20px;
        top: 10px;
        &.code-right {
          right: -156px;
        }
      }
      .error {
        padding-left: 49px;
        color: #ff1f2a;
        font-size: 14px;
        position: absolute;
        bottom: -35px;
        &.imgerror {
          padding-left: 78px;
        }
        &.psw-error {
          padding-left: 78px;
        }
        &.code-error {
          padding-left: 63px;
        }
      }
      .prev-btn {
        float: right;
        color: #5779fa;
        cursor: pointer;
      }
    }
  }
  .next-box {
    position: relative;
    width: 80%;
    margin: 0 auto;
    .back-login {
      position: absolute;
      right: 36px;
      bottom: -22px;
      height: 40px;
      span {
        color: #5779fa;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .next-button {
    width: 160px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    border-radius: 10px;
    border: none;
    background-color: #5779fa;
    font-size: 14px;
    cursor: pointer;
    &.sbtn-disabled {
      background-color: #ddd;
      cursor: not-allowed;
    }
  }
}
</style>
